import Screening from "./Screening";

export default Screening;